
import { Station } from "@/api/dtos/Station.schema";
import ContainerFrame from "@/components/ContainerFrame.vue";
import { StationsModule } from "@/store/modules/StationsModule";
import { Component, Vue } from "vue-property-decorator";
import MonthlyUtilizationView from "@/components/stationDetails/MonthlyUtilizationView.vue";

@Component({
  components: {
    MonthlyUtilizationView,
    ContainerFrame,
  },
})
export default class StationUtilizationView extends Vue {
  selectedDeviceType: string | null = null;

  mounted(): void {
    StationsModule.fetchDetailedStation(this.$route.params.stationUuid);
  }

  get station(): Station | null {
    return StationsModule.detailedStation;
  }

  get deviceTypeItems(): string[] {
    const s = this.station;
    if (!s) return [];
    const set = new Set<string>();
    s.devices.forEach((d) => {
      const t = d?.typeSettings?.assignedType;
      if (t) set.add(t);
    });
    return Array.from(set).sort((a, b) => a.localeCompare(b));
  }
}
